import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BarSup.css';

const BarSup = () => {
  const [categorias, setCategorias] = useState([]);
  const location = useLocation();
  
  // Sistema de throttling con useRef para mejor control
  const lastFetchRef = useRef(0);
  const THROTTLE_DELAY = 30000; // 30 segundos

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        // Throttling: solo recargar cada 30 segundos
        const now = Date.now();
        if (now - lastFetchRef.current < THROTTLE_DELAY) {
          return;
        }
        lastFetchRef.current = now;
        
        const res = await fetch('https://api.minymol.com/categories/with-products-and-images');
        
        if (!res.ok) {
          if (res.status === 429) {
            return; // Silenciar rate limiting completamente
          }
          throw new Error(`HTTP ${res.status}`);
        }
        
        const data = await res.json();
        setCategorias(data);
      } catch (err) {
        // Silenciar completamente errores de rate limiting y de red
        if (!err.message?.includes('429') && !err.name?.includes('TypeError')) {
          console.error('Error al cargar categorías:', err);
        }
      }
    };

    fetchCategorias();
  }, []);

  const currentSlug = location.pathname.split('/category/')[1]?.split('/')[0];

  return (
    <div className='bar-sup'>
      <Link
        to="/"
        id="link-sup"
        className={location.pathname === '/' ? 'selected' : ''}
      >
        Todos
      </Link>

      {categorias.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          id="link-sup"
          className={currentSlug === cat.slug ? 'selected' : ''}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
};

export default BarSup;
